import { createReducer, on, createFeature } from '@ngrx/store'
import { AppliedLeaveState } from './applied-leave.state'
import {
  createAppliedLeave,
  createAppliedLeaveFailure,
  createAppliedLeaveSuccess,
  loadAppliedLeaves,
  loadAppliedLeavesFailure,
  loadAppliedLeavesSuccess,
  updateAppliedLeave,
  updateAppliedLeaveFailure,
  updateAppliedLeaveSuccess
} from './applied-leave.actions'

export const initialState: AppliedLeaveState = {
  appliedLeaves: [],
  loading: false,
  error: null,
  totalCount: 0
}

export const appliedLeaveReducer = createReducer(
  initialState,
  on(loadAppliedLeaves, state => ({
    ...state,
    loading: true,
    error: null
  })),
  on(loadAppliedLeavesSuccess, (state, { totalCount, appliedLeaves }) => ({
    ...state,
    totalCount,
    appliedLeaves: appliedLeaves,
    loading: false,
    error: null
  })),
  on(loadAppliedLeavesFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error
  })),
  on(createAppliedLeave, state => ({ ...state, loading: true })),
  on(createAppliedLeaveSuccess, (state, { appliedLeave }) => ({
    ...state,
    appliedLeaves: [...state.appliedLeaves, appliedLeave],
    loading: false
  })),
  on(createAppliedLeaveFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error
  })),
  on(updateAppliedLeave, state => ({ ...state, loading: true })),
  on(updateAppliedLeaveSuccess, (state, { appliedLeave }) => ({
    ...state,
    appliedLeave,
    loading: false
  })),
  on(updateAppliedLeaveFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error
  }))
)

// Create the feature for the business state
export const appliedLeaveFeature = createFeature({
  name: 'AppliedLeave', // Feature name
  reducer: appliedLeaveReducer
})
export type { AppliedLeaveState }
// Export the feature's selectors
export const { name, reducer, selectAppliedLeaves, selectLoading, selectError, selectTotalCount } =
  appliedLeaveFeature
